import m from "../../geodata/es2015/unRegionsHigh";
window.am4geodata_unRegionsHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/unRegionsHigh.js
// module id = null
// module chunks = 